import { RenderIf } from 'react-rainbow-components';
import Button from 'components/Button';
import AlertTriangle from 'components/icons/alertTriangle';
import { useNexhealthPatient } from '../hooks';
import Alerts from '../CustomerNexhealthTab/alerts';
import Appointments from '../CustomerNexhealthTab/appointments';
import Demographics from '../CustomerNexhealthTab/demographics';
import {
    EmptyMessageContainer,
    EmptyMessageDescription,
    EmptyMessageIcon,
    EmptyMessageTitle,
} from '../CustomerNexhealthTab/styled';
import { PanelBody, SkeletonBlock, SkeletonLine } from './styled';

const CustomerNexhealthPanel = ({
    agentId,
    customerId,
    patientId,
}: {
    agentId: string;
    customerId: string;
    patientId: number;
}) => {
    const {
        data: patientResult,
        isLoading,
        isError,
        refetch,
    } = useNexhealthPatient(agentId, customerId, true);
    const patient = patientResult?.data;

    return (
        <PanelBody>
            <RenderIf isTrue={isLoading}>
                <SkeletonBlock>
                    <SkeletonLine shape="rounded-rect" width="40%" height="1.25rem" />
                    <SkeletonLine shape="rounded-rect" width="70%" height="0.75rem" />
                    <SkeletonLine shape="rounded-rect" width="100%" height="0.75rem" />
                    <SkeletonLine shape="rounded-rect" width="85%" height="0.75rem" />
                </SkeletonBlock>
            </RenderIf>
            <RenderIf isTrue={!isLoading && isError}>
                <EmptyMessageContainer>
                    <EmptyMessageIcon>
                        <AlertTriangle />
                    </EmptyMessageIcon>
                    <EmptyMessageTitle>Couldn&apos;t load NexHealth</EmptyMessageTitle>
                    <EmptyMessageDescription>
                        Something went wrong while loading the NexHealth information
                        for this customer.
                    </EmptyMessageDescription>
                    <Button
                        variant="brand"
                        borderRadius="semi-rounded"
                        label="Try again"
                        onClick={() => refetch()}
                    />
                </EmptyMessageContainer>
            </RenderIf>
            <RenderIf isTrue={!isLoading && !isError && patient}>
                <Demographics patient={patient!} compact />
                <Alerts agentId={agentId} patientId={patientId} />
                <Appointments
                    agentId={agentId}
                    customerId={customerId}
                    showRangeFilter={false}
                    minimal
                />
            </RenderIf>
        </PanelBody>
    );
};

export default CustomerNexhealthPanel;
